import { Typography, Box } from "@mui/material";
import { UserCategoryActionsPopover } from "./user-category-actions-popover";
import { formatLabel } from "@/utils/format-label";

export const getUsersCategoryColumns = (onMoveClick) => [
  {
    accessorKey: "id",
    header: () => <div>ID</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">{row.original.id}</Typography>
    ),
  },
  {
    accessorKey: "userId",
    header: () => <div style={{ whiteSpace: "nowrap" }}>User ID</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">{row.original.userId ?? "—"}</Typography>
    ),
  },
  {
    accessorKey: "user.name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>User Name</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {formatLabel(row.original.user?.name) ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "user.email",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Email Address</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.user?.email ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "category.name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Category</div>,
    cell: ({ row }) => (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          py: 0.5,
          borderRadius: "999px",
          backgroundColor: "#eff6ff",
          color: "#1d4ed8",
          fontSize: "0.8rem",
          fontWeight: 500,
          whiteSpace: "nowrap",
        }}
      >
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: "#2563eb",
          }}
        />
        {row.original.category?.name ?? "—"}
      </Box>
    ),
  },
  {
    accessorKey: "category.code",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Category Code</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.category?.code ?? "—"}
      </Typography>
    ),
  },
  {
    id: "actions",
    header: () => <div>Actions</div>,
    cell: ({ row }) => (
      <UserCategoryActionsPopover
        user={row.original}
        onMoveClick={onMoveClick}
      />
    ),
  },
];
